import { render, staticRenderFns } from "./email-setup-stepper.vue?vue&type=template&id=27aa97de&scoped=true"
import script from "./email-setup-stepper.vue?vue&type=script&lang=ts"
export * from "./email-setup-stepper.vue?vue&type=script&lang=ts"
import style0 from "./email-setup-stepper.vue?vue&type=style&index=0&id=27aa97de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa97de",
  null
  
)

export default component.exports